import Rails from '@rails/ujs'
import $ from 'jquery'
import Foundation from 'foundation-sites' // eslint-disable-line no-unused-vars
import { init as initApm } from '@elastic/apm-rum'

// Jquery
window.$ = $ // gives other packages access to `$` (eg. @rails/ujs)

// Rails UJS
if (!window._rails_loaded) { // for some reason, when we use bundled javascript, this has already loaded and errors
  Rails.start()
}

// load and init foundation JS
document.addEventListener('DOMContentLoaded', () => $(document).foundation())

// ElasticAPM
initApm({
  // Set required service name (allowed characters: a-z, A-Z, 0-9, -, _, and space)
  serviceName: 'Any Questions',
  // Set custom APM Server URL (default: http://localhost:8200)
  serverUrl: 'https://apm-server.digitalnz.org',
  // Set service version (required for sourcemap feature)
  serviceVersion: '',
  environment: import.meta.env.RAILS_ENV,
  active: false
  // to enable the elastic apm again
  // active:
  //   process.env.RAILS_ENV == "staging" || process.env.RAILS_ENV == "production",
})
